import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAirtableRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 31 31",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#FCB400",
			d: "M14.314 6.12225L5.93086 9.59104C5.46467 9.78397 5.4695 10.4463 5.93861 10.6322L14.3567 13.9705C15.0963 14.2638 15.92 14.2638 16.6597 13.9705L25.0779 10.6321C25.5469 10.4463 25.552 9.78409 25.0855 9.59116L16.7026 6.12212C15.9378 5.80565 15.0787 5.80565 14.3139 6.12212"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#18BFFF",
			d: "M16.2598 15.7934V24.133C16.2598 24.5295 16.6597 24.8012 17.0284 24.6551L26.4088 21.0141C26.5134 20.9726 26.6031 20.9006 26.6664 20.8075C26.7296 20.7144 26.7634 20.6045 26.7634 20.492V12.1525C26.7634 11.7559 26.3634 11.4843 25.9947 11.6304L16.6144 15.2714C16.5098 15.3129 16.42 15.3849 16.3568 15.478C16.2936 15.5711 16.2598 15.6809 16.2598 15.7934Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#F82B60",
			d: "M14.0606 16.2239L11.2768 17.568L10.9941 17.7046L5.11751 20.5204C4.74512 20.7001 4.26953 20.4287 4.26953 20.0148V12.1876C4.26953 12.0379 4.3463 11.9086 4.44924 11.8114C4.49148 11.7693 4.53939 11.7334 4.59159 11.7046C4.7319 11.6204 4.9322 11.5979 5.10251 11.6652L14.0139 15.1962C14.4668 15.3759 14.5024 16.0105 14.0606 16.2239Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#000",
			fillOpacity: .25,
			d: "M14.0684 16.2239L11.2845 17.568L4.45703 11.8113C4.49927 11.7693 4.54719 11.7334 4.59938 11.7046C4.73969 11.6204 4.93999 11.5979 5.1103 11.6652L14.0217 15.1962C14.4746 15.3759 14.5102 16.0105 14.0684 16.2239Z"
		})
	]
});
export default SvgAirtableRegularIcon;
